import { LogoutRounded, MoreVertRounded } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  dividerClasses,
  listClasses,
  listItemIconClasses,
  paperClasses,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useTranslation } from "@/context/I18nProvider";
import { logoutUser } from "@/services";
import { dispatch, logout, useSelector } from "@/store";
import { MenuItem } from "@/theme";

export default function OptionsMenu() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const currentUserId = useSelector((state) => state.auth.user?._id);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleProfile = () => {
    handleClose();
    if (!currentUserId) return;

    // The profile page reads the target id from history state, not the URL.
    navigate(ROUTES.USER_PROFILE, { state: { userId: currentUserId } });
  };
  const handleLogout = async () => {
    handleClose();
    try {
      await logoutUser();
    } catch {
      // Server-side cleanup failed (network blip, already-expired session).
      // Continue with local logout - leaving the user signed in would be worse.
    }
    dispatch(logout());
  };

  return (
    <>
      <IconButton
        size="small"
        aria-label={t("common.openMenu")}
        onClick={handleClick}
        sx={{ borderColor: "transparent" }}
      >
        <MoreVertRounded />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{
          [`& .${listClasses.root}`]: {
            padding: "4px",
          },
          [`& .${paperClasses.root}`]: {
            padding: 0,
          },
          [`& .${dividerClasses.root}`]: {
            margin: "4px -4px",
          },
        }}
      >
        <MenuItem onClick={handleProfile}>{t("common.profile")}</MenuItem>
        <Divider />
        <MenuItem
          onClick={handleLogout}
          sx={{
            [`& .${listItemIconClasses.root}`]: {
              ml: "auto",
              minWidth: 0,
            },
          }}
        >
          <ListItemText>{t("common.logout")}</ListItemText>
          <ListItemIcon>
            <LogoutRounded fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  );
}
